/*
  Author: Vaishnavi
  Date: 19/11/2019
  Issue NO:-
  Description: Visual Bugs fixes raised by Harshvardhan Kore & Tarun Bhandari
*/
<template>
  <div class="business">
    <div>
      <div class="top-bar">
        <img @click="backToFbp" src="@/assets/path-2-copy.png" />
        <span class="heading_new">{{ heading }}</span>
      </div>
      <toast-message
        :message="errmsg"
        type="error"
        :isToastEnable="toast"
        @close="(val) => toast = val"
      />
      <div class="content-new">
        <div class="row">
          <div class="col-3">
            <txt
              autofocus="autofocus"
              label="Name of FBP Band *"
              type="text"
              v-model="formData.name"
              name="FBPName"
              data-vv-as="Name"
              v-validate="{required: true}"
              :classname="errors.has('FBPName')"
              :errormsg="errors.first('FBPName')"
            />
          </div>
        </div>
        <div class="row margin-t-m">
          <div class="col-3">
            <txt
              label="From CTC (In Rupee) *"
              type="number"
              name="fromCtc"
              v-numeric-only
              v-maxchars="9"
              v-model="formData.fromCtc"
              data-vv-as="From"
              v-validate="`required|min_value:0|max:9`"
              :classname="errors.has('fromCtc')"
              :errormsg="errors.first('fromCtc')"
            />
          </div>
          <div class="col-3">
            <txt
              label="To CTC (In Rupee) *"
              type="number"
              name="toCtc"
              v-numeric-only
              v-maxchars="9"
              v-model="formData.toCtc"
              data-vv-as="To"
              v-validate="`required|min_value:${parseInt(formData.fromCtc ? (Number(formData.fromCtc) +1) : (0+1))}|max:9`"
              :classname="errors.has('toCtc')"
              :errormsg="errors.first('toCtc')"
            />
          </div>
        </div>
        <div class="row margin-t-m">
          <div class="col-3">
            <txt
              name="fbpDescription"
              label="Description"
              type="textarea"
              v-model="formData.description"
              data-vv-as="description"
              v-validate="{required: false, max: descriptionMaxlength}"
              :classname="errors.has('fbpDescription')"
              :errormsg="errors.first('fbpDescription')"
            ></txt>
          </div>
        </div>
        <bottom-action-container>
          <template slot="end">
            <btn-grp>
              <btn text="Cancel" type="secondary" @click="backToFbp" />
              <btn :text="btnText" type="primary" @click="save" />
            </btn-grp>
          </template>
        </bottom-action-container>
        <pop-up-message
          v-if="showSuccessMsg"
          :message="`${formData.name} has been successfully ${editMode ? 'updated' : 'created'}`"
          btnText="Back To FBP Bands"
          @back="backToFbp"
        ></pop-up-message>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import * as config from "@/apis/config.js";

export default {
  name: "addFbpBand",

  data() {
    return {
      nameMaxlength: null,
      descriptionMaxlength: null,
      showForm: false,
      selectedBuType: "",
      formData: {
        name: "",
        fromCtc: null,
        toCtc: null,
        description: ""
      },
      errmsg: "",
      toast: false,
      showSuccessMsg: false
    };
  },
  computed: {
    editMode() {
      return this.$store.getters["onboard/fbpBands/editMode"];
    },
    record() {
      return (this.formData = this.$store.getters["onboard/fbpBands/record"]);
    },
    btnText() {
      if (this.editMode) {
        return "Update";
      } else {
        return "Add New";
      }
      this.toast = false;
    },
    heading() {
      if (this.editMode) {
        return "FBP Bands - " + this.record.name;
      } else {
        return "FBP Bands";
      }
    },
    ...mapGetters({
      getleid: "onboard/legal_entities/legal_entity_ID"
    }),
    le_id() {
      if (this.$route.params.entity_index) {
        return this.getleid(this.$route.params.entity_index);
      }
      return this.getleid(0);
    }
  },
  activated() {
    this.toast = false;
    this.setGlobalValidations();
    if (this.editMode) {
      this.formData;
    } else {
      this.refresh();
    }
  },
  methods: {
    ...mapActions({
      act_create: "onboard/fbpBands/create",
      act_update: "onboard/fbpBands/update"
    }),

    /* function to set validation */
    setGlobalValidations() {
      try {
        this.nameMaxlength = config.MaxLengthSettings.nameLength;
        this.descriptionMaxlength = config.MaxLengthSettings.descriptionLength;
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    /* function to go back to FBP band table page */
    backToFbp() {
      this.showSuccessMsg = false;
      this.refresh();
      this.$router.push({
        path: `/onboarding/entity/${this.$route.params.entity_index}/misc`,
        query: {
          stepindex: 1
        }
      });
    },

    /* function to refrsh the page */
    refresh() {
      try {
        this.formData = {
          name: "",
          fromCtc: null,
          toCtc: null,
          description: ""
        };
        this.$validator.reset();
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    /* function to submit the form data */
    async performAction() {
      try {
        this.$root._data.isSaving = true;
        let res = null;
        if (this.editMode) {
          res = await this.act_update(this.formData);
        } else {
          res = await this.act_create({ ...this.formData, le_id: this.le_id });
        }
        if (res.data.status) {
          this.showSuccessMsg = true;
        }
        setTimeout(() => {
          this.$root._data.isSaving = false;
        }, 500);
      } catch (err) {
        this.$root._data.isSaving = false;
        this.toast = true;
        this.errmsg = err;
      }
    },

    /* function to validate the form */
    async save() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.performAction();
        } else {
          this.$el
            .querySelector(
              '[data-vv-name="' + this.$validator.errors.items[0].field + '"]'
            )
            .focus();
          this.$el
            .querySelector(
              '[data-vv-name="' + this.$validator.errors.items[0].field + '"]'
            )
            .scrollIntoView({
              behavior: "smooth",
              block: "center",
              inline: "center"
            });
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/scss/components/margins.scss";
.content-new {
  margin: 32px 32px;
  .errorr {
    border: 1px solid #e01717;
  }
  .errorMessage {
    color: #e01717;
    // padding-top: 1px
  }
}

.business {
  width: 100%;
  height: 100%;
  .top-bar {
    height: 64px;
    display: flex;
    box-shadow: 0 1px 18px 0 rgba(0, 0, 0, 0.12);
    background-color: #ffffff;
    padding: 24px 0 0 32px;
    img {
      cursor: pointer;
      margin-right: 24px;
      width: 10px;
      height: 16px;
    }
  }
}

.heading_new {
  height: 19px;
  font-size: 16px;
  font-weight: 600;
  color: #6e6e6e;
}
</style>
